import React from 'react';
import { useContact } from '../context/ContactContext';
import { API_URL } from '../config/api';
import './Logo.css';

function Logo({ size = 'medium', showText = true }) {
  const { contactSettings } = useContact();
  const logoUrl = contactSettings.logoUrl;

  const sizeClasses = {
    small: 'logo-small',
    medium: 'logo-medium',
    large: 'logo-large'
  };

  // When a custom logo is uploaded, render it as a full logo (no icon box + text)
  if (logoUrl) {
    return (
      <div className={`logo-container logo-has-custom ${sizeClasses[size]}`}>
        <img
          src={`${API_URL}${logoUrl}`}
          alt="Site Logo"
          className="logo-custom-image"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </div>
    );
  }

  return (
    <div className={`logo-container ${sizeClasses[size]}`}>
      <div className="logo-icon">
        <img src="/logo.svg" alt="FlyTravelDeals logo" />
      </div>
      
      {showText && (
        <div className="logo-text">
          <span className="logo-fly">Fly</span>
          <span className="logo-travel">Travel</span>
          <span className="logo-deals">Deals</span>
        </div>
      )}
    </div>
  );
}

export default Logo;
